import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

// Admin/moderator কে — সেটা এখন ডাটাবেসের profiles.role থেকে আসে (supabase/migrations/0002),
// কোডে hard-coded ইমেইল নেই। এখানকার check শুধু UI দেখানোর জন্য; আসল অনুমতি দেয়/আটকায় RLS।
export const STAFF_ROLES = ["moderator", "admin"];

export async function sendMagicLink(email) {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: { emailRedirectTo: window.location.origin + "/admin" },
  });
  if (error) throw error;
}

export async function signOutAdmin() {
  await supabase.auth.signOut();
}

// নিজের profile row পড়া RLS-এ অনুমোদিত। row না থাকলে (এখনো তৈরি হয়নি) সাধারণ ইউজার ধরা হয়।
async function fetchMyRole(userId) {
  const { data, error } = await supabase.from("profiles").select("role").eq("id", userId).maybeSingle();
  if (error) throw error;
  return data?.role ?? "user";
}

// লগইন/লগআউট অবস্থা রিয়েল-টাইমে — magic link-এর ইমেইল থেকে ফিরে আসার পর
// supabase-js নিজে থেকেই URL থেকে session ধরে নেয়, onAuthStateChange সেটা জানিয়ে দেয়।
export function useAdminSession() {
  const [session, setSession] = useState(undefined); // undefined = still loading
  const [fetched, setFetched] = useState({ userId: null, role: undefined }); // কোন ইউজারের role আনা হয়েছে

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session ?? null);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const userId = session?.user?.id ?? null;

  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;
    fetchMyRole(userId)
      .then((role) => !cancelled && setFetched({ userId, role }))
      .catch(() => !cancelled && setFetched({ userId, role: "user" }));
    return () => {
      cancelled = true;
    };
  }, [userId]);

  // role render-এর সময় বের করা হয় (effect-এ সরাসরি setState নয়): লগইন না থাকলে null,
  // থাকলে — আনা হয়ে গেলে সেটা, নইলে undefined (লোড হচ্ছে)।
  const role = !userId ? (session === undefined ? undefined : null) : fetched.userId === userId ? fetched.role : undefined;

  return {
    session,
    loading: session === undefined || (!!userId && role === undefined),
    email: session?.user?.email ?? null,
    role,
    isStaff: STAFF_ROLES.includes(role),
    isAdmin: role === "admin",
  };
}
